export default __webpack_public_path__ + "static/media/requested.3163e4a6.svg";